import { Toaster as Sonner, toast } from "sonner"

// The app passes `theme` from ThemeContext (see ThemedToaster in App.js).
const Toaster = ({ theme = "light", ...props }) => {
  return (
    <Sonner
      theme={theme}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:rounded-md group-[.toaster]:border-line group-[.toaster]:bg-surface group-[.toaster]:font-body group-[.toaster]:text-ink group-[.toaster]:shadow-overlay",
          title: "group-[.toast]:text-[15px] group-[.toast]:font-bold",
          description: "group-[.toast]:text-sm group-[.toast]:text-ink-muted",
          actionButton:
            "group-[.toast]:bg-marker group-[.toast]:font-bold group-[.toast]:text-on-marker",
          cancelButton:
            "group-[.toast]:bg-sunken group-[.toast]:text-ink",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
